export interface HeaderRecordProps {
  field: string;
  hideable: boolean;
  headerName: string;
  editable?: boolean;
  sortable?: boolean;
  headerAlign?: string;
}

export interface RecordsDataProps {
  id: string;
  product: string;
  totalAdvisingPaymentLimitCountStart: number;
  singleAdvisorActivityPaymentLimitCountStart: number;
  advisoryBoardPaymentLimitCountUsed: number;
  singleAdvisorActivityPaymentLimitCountUsed: number;
  totalAdvisingPaymentRemaining: number;
  singleAdvisorActivityPaymentRemaining: number;
}

export const IndividualPaymentLimitsReportColumns = ({
  setDataGridColumns,
  setDataGridHeight,
  setDataGridHeaderMedia,
}: {
  setDataGridColumns: React.Dispatch<React.SetStateAction<HeaderRecordProps[]>>;
  setDataGridHeight: React.Dispatch<React.SetStateAction<string>>;
  setDataGridHeaderMedia: React.Dispatch<React.SetStateAction<number>>;
}) => {
  if (
    window.matchMedia("(min-width: 1366px) and (max-resolution: 100dpi)")
      .matches
  ) {
    const dataGridHeaderColumn = [
      {
        field: "product",
        hideable: false,
        headerName: "Product",
        headerAlign: "left",
        flex: 1,
        minWidth: 250,
      },
      {
        field: "totalAdvisingPaymentLimitCountStart",
        hideable: false,
        headerName: "Total Advising Payment Limit Count - Start",
        headerAlign: "center",
        flex: 1,
        minWidth: 170,
      },
      {
        field: "singleAdvisorActivityPaymentLimitCountStart",
        hideable: false,
        headerName: "Single Advisor Activity Payment Limit Count - Start",
        headerAlign: "center",
        flex: 1,
        minWidth: 180,
      },
      {
        field: "advisoryBoardPaymentLimitCountUsed",
        hideable: false,
        headerName: "Advisory Board Payment Limit Count - Used",
        headerAlign: "center",
        flex: 1,
        minWidth: 180,
      },
      {
        field: "singleAdvisorActivityPaymentLimitCountUsed",
        hideable: false,
        headerName: "Single Advisor Activity Payment Limit Count - Used",
        headerAlign: "center",
        flex: 1,
        minWidth: 180,
      },
      {
        field: "totalAdvisingPaymentRemaining",
        hideable: false,
        headerName: "Total Advising Payment Remaining",
        headerAlign: "center",
        flex: 1,
        minWidth: 170,
      },
      {
        field: "singleAdvisorActivityPaymentRemaining",
        hideable: false,
        headerName: "Single Advisor Activity Payment Remaining",
        headerAlign: "center",
        flex: 1,
        minWidth: 180,
      },
    ];
    setDataGridColumns(dataGridHeaderColumn);
    setDataGridHeight("350px");
    setDataGridHeaderMedia(95);
  } else if (
    window.matchMedia("(min-width: 1366px) and (max-resolution: 125dpi)")
      .matches
  ) {
    const dataGridHeaderColumn = [
      {
        field: "product",
        hideable: false,
        headerName: "Product",
        headerAlign: "left",
        flex: 1,
        minWidth: 250,
      },
      {
        field: "totalAdvisingPaymentLimitCountStart",
        hideable: false,
        headerName: "Total Advising Payment Limit Count - Start",
        headerAlign: "center",
        flex: 1,
        minWidth: 150,
      },
      {
        field: "singleAdvisorActivityPaymentLimitCountStart",
        hideable: false,
        headerName: "Single Advisor Activity Payment Limit Count - Start",
        headerAlign: "center",
        flex: 1,
        minWidth: 180,
      },
      {
        field: "advisoryBoardPaymentLimitCountUsed",
        hideable: false,
        headerName: "Advisory Board Payment Limit Count - Used",
        headerAlign: "center",
        flex: 1,
        minWidth: 150,
      },
      {
        field: "singleAdvisorActivityPaymentLimitCountUsed",
        hideable: false,
        headerName: "Single Advisor Activity Payment Limit Count - Used",
        headerAlign: "center",
        flex: 1,
        minWidth: 150,
      },
      {
        field: "totalAdvisingPaymentRemaining",
        hideable: false,
        headerName: "Total Advising Payment Remaining",
        headerAlign: "center",
        flex: 1,
        minWidth: 150,
      },
      {
        field: "singleAdvisorActivityPaymentRemaining",
        hideable: false,
        headerName: "Single Advisor Activity Payment Remaining",
        headerAlign: "center",
        flex: 1,
        minWidth: 150,
      },
    ];
    setDataGridColumns(dataGridHeaderColumn);
    setDataGridHeight("500px");
    setDataGridHeaderMedia(100);
  } else {
    const dataGridHeaderColumn = [
      {
        field: "product",
        hideable: false,
        headerName: "Product",
        headerAlign: "left",
        flex: 1,
        minWidth: 250,
      },
      {
        field: "totalAdvisingPaymentLimitCountStart",
        hideable: false,
        headerName: "Total Advising Payment Limit Count - Start",
        headerAlign: "center",
        flex: 1,
        minWidth: 150,
      },
      {
        field: "singleAdvisorActivityPaymentLimitCountStart",
        hideable: false,
        headerName: "Single Advisor Activity Payment Limit Count - Start",
        headerAlign: "center",
        flex: 1,
        minWidth: 150,
      },
      {
        field: "advisoryBoardPaymentLimitCountUsed",
        hideable: false,
        headerName: "Advisory Board Payment Limit Count - Used",
        headerAlign: "center",
        flex: 1,
        minWidth: 150,
      },
      {
        field: "singleAdvisorActivityPaymentLimitCountUsed",
        hideable: false,
        headerName: "Single Advisor Activity Payment Limit Count - Used",
        headerAlign: "center",
        flex: 1,
        minWidth: 150,
      },
      {
        field: "totalAdvisingPaymentRemaining",
        hideable: false,
        headerName: "Total Advising Payment Remaining",
        headerAlign: "center",
        flex: 1,
        minWidth: 150,
      },
      {
        field: "singleAdvisorActivityPaymentRemaining",
        hideable: false,
        headerName: "Single Advisor Activity Payment Remaining",
        headerAlign: "center",
        flex: 1,
        minWidth: 150,
      },
    ];
    setDataGridColumns(dataGridHeaderColumn);
    setDataGridHeight("330px");
    setDataGridHeaderMedia(70);
  }
};
